import { FormGroup, TextInput } from '@allurion/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { z } from 'zod';

import { TrackedButton } from 'src/analytics/TrackedUI';
import globalMessages from 'src/messages/global.messages';

import messages from './reset-password-messages';

import styles from './ResetPasswordForm.module.scss';

type Props = {
  onSubmit: (values: FormValues) => void;
};

type FormValues = {
  email: string;
};

export function ResetPasswordForm({ onSubmit }: Props) {
  const intl = useIntl();

  const ResetPasswordForm = z
    .object({
      email: z
        .email(intl.formatMessage(globalMessages.notValidEmail))
        .nonempty(intl.formatMessage(globalMessages.required)),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: zodResolver(ResetPasswordForm),
  });

  return (
    <>
      <p className={styles.text}>{intl.formatMessage(globalMessages.resetPasswordEmailText)}</p>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <FormGroup label={intl.formatMessage(messages.email)} error={errors.email?.message}>
          <TextInput
            type="email"
            placeholder={intl.formatMessage(messages.emailPlaceholder)}
            {...register('email')}
          />
        </FormGroup>
        <div className={styles.controls}>
          <TrackedButton
            label={intl.formatMessage(globalMessages.resetPassword)}
            type="submit"
            variant="secondary"
            trackLabel="submit-reset-password"
          />
        </div>
      </form>
    </>
  );
}
